import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["field", "reset"];
  static values = { default: String };

  connect() {
    this.refresh();
  }

  append(event) {
    const token = event.params.token;
    if (this.fieldTarget.value.includes(token)) return;

    const current = this.fieldTarget.value.trimEnd();
    this.fieldTarget.value = current ? `${current} ${token}` : token;
    this.changed();
  }

  restoreDefault() {
    this.fieldTarget.value = this.defaultValue;
    this.changed();
  }

  refresh() {
    this.resetTarget.hidden = this.fieldTarget.value === this.defaultValue;
  }

  changed() {
    this.fieldTarget.dispatchEvent(new Event("input", { bubbles: true }));
    this.fieldTarget.focus();
  }
}
